import { CSSObject } from '@mantine/core';
import { textVariants } from '@ui/tokens/typography/typography';
import { MantineThemeComponent } from '../../types';

// Workaround to default styles in DesignSystem.scss that set
// ul and li list-style-type to none
const CheckboxDefaultConfig: MantineThemeComponent = {
	styles: (): Record<string, CSSObject> => ( {
		body: {
			gap: '8px'
		},
		inner: {
			marginTop: '2px'
		},
		label: {
			paddingLeft: 0,
			...( textVariants.body as CSSObject )
		}
	} )
};

export default CheckboxDefaultConfig;
